export default {
  mediaPlayerEvents: {
    skipForward: 'skipForward',
    skipBackward: 'skipBackward'
  }
};
